import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/app/environment';
import { CookieService } from 'ngx-cookie-service';
import * as _ from 'underscore';
import { GlobalService } from '../global.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private apiUrl = environment.link_api_dev;
  public user: any;
  private isLoggedIn = false;
  public userPermissions: any = {};
  public baseApiUrl: string;

  constructor(
    private http: HttpClient,
    private cookies: CookieService,
    private globalService: GlobalService
  ) {
    this.baseApiUrl = this.globalService.domainApi;
  }

  login(user: any): Observable<any> {
    return this.http.post(this.baseApiUrl +'login', user);
  }

  verifyOtp(data: any): Observable<any> {
    return this.http.post(this.baseApiUrl + 'verify-otp', data);
  }

  logout(): Observable<any> {
    return this.http.get(this.baseApiUrl +'logout');
  }

  permissions(): Observable<any> {
    return this.http.get(this.globalService.getSlugBranchoffice()+this.baseApiUrl +'permissions');
  }

  setUserData(data: any): void {
    this.cookies.set('user_data', JSON.stringify(data));
    this.user = data;
  }

  setUserPermissions(data: any): void {
    localStorage.setItem('userPermissions', JSON.stringify(data));
    this.userPermissions = data;
  }

  getUser() {
    return JSON.parse(this.cookies.get('user_data'));
  }

  getUserPermissions() {
    // return this.userPermissions;
    let data: any = localStorage.getItem('userPermissions');
    return JSON.parse(data);
  }

  setToken(token: string): void {
    this.cookies.set('token', token);
    this.isLoggedIn = true;
  }

  getToken() {
    return this.cookies.get('token');
  }

  removeToken():void {
    this.cookies.delete('token');
  }

  removeUserData():void {
    this.cookies.delete('user_data');
  }

  removeUserPermissions():void {
    localStorage.clear();
  }

  isAuthenticated(): boolean {
    if (!_.isUndefined(this.getToken())) {
      if (!_.isNull(this.getToken())) {
        if (this.getToken() !== '') {
          return true;
        }
      }
    }
    return false;
  }
  
}
